export const RESTART_FILTERS = "REMOVE_FILTERS";

export const FILTER_BY_ACTIVITY = "FILTER_BY_ACTIVITY";

export const FILTER_BY_CONTINENT = "FILTER_BY_ACTIVITY";

export const SORT = "SORT_COUNTRIES";

export const GET_COUNTRIES = "GET_COUNTRIES";

export const GET_CONTINENTS = "GET_CONTINENTS";

export const FILTER_BY_NAME = "FILTER_BY_NAME";

export const SET_LOADING = "SET_LOADING";

export const CREATE_ACTIVITY = "CREATE_ACTIVITY";

export const SET_OPTIONS = "SET_OPTIONS";

export const RESTART_COUNTRIES = "RESTART_COUNTRIES";

export const PAGINATE_COUNTRIES = "PAGINATE_COUNTRIES";

export const CHANGE_PAGE = "CHANGE_PAGE";

export const ADD_NOTIFICATION = "ADD_NEW_NOTIFICATION";

export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION_BY_ID";